function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Cost table
 * 
 */
import React from 'react';
import { COSTS } from '../../../data/Data';
import { connect } from 'react-redux';
import './CostTable.scss';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class CostTable extends React.Component {
  render() {
    const {
      postage
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      className: "cost-table",
      children: [/*#__PURE__*/_jsx("div", {
        className: "title",
        children: "Total Cost"
      }), /*#__PURE__*/_jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/_jsx("span", {
          className: "description",
          children: "International Driving Permit"
        }), /*#__PURE__*/_jsxs("span", {
          className: "cost",
          children: [/*#__PURE__*/_jsx("span", {
            className: "currency",
            children: "AUD"
          }), /*#__PURE__*/_jsxs("span", {
            className: "value",
            children: ["$", COSTS.permit, ".00"]
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/_jsx("span", {
          className: "description",
          children: postage.description
        }), /*#__PURE__*/_jsxs("span", {
          className: "cost",
          children: [/*#__PURE__*/_jsx("span", {
            className: "currency",
            children: "AUD"
          }), /*#__PURE__*/_jsxs("span", {
            className: "value",
            children: ["$", postage.cost.toFixed(2)]
          })]
        })]
      }), this.props.selectedStore && /*#__PURE__*/_jsxs("div", {
        className: "row selected-store-details",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "title",
          children: ["Selected store", /*#__PURE__*/_jsxs(Link, {
            className: "edit",
            to: "/details#store-selector",
            children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: "pencil"
            }), " Edit"]
          })]
        }), /*#__PURE__*/_jsxs("p", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: this.props.selectedStore.name
          }), /*#__PURE__*/_jsx("br", {}), this.props.selectedStore.address_1, /*#__PURE__*/_jsx("br", {}), this.props.selectedStore.address_2 && /*#__PURE__*/_jsxs(React.Fragment, {
            children: [this.props.selectedStore.address_2, /*#__PURE__*/_jsx("br", {})]
          }), this.props.selectedStore.address_suburb, ", ", this.props.selectedStore.address_state]
        })]
      }), this.props.deliveryPickupPerson && this.props.deliveryPickupPerson.value && /*#__PURE__*/_jsxs("div", {
        className: "row pickup-option-details",
        children: [/*#__PURE__*/_jsx("div", {
          className: "title",
          children: "Pickup option"
        }), /*#__PURE__*/_jsx("p", {
          children: this.props.deliveryPickupPerson.value === 'self' ? 'I will pick up my IDP at the selected store.' : 'Someone else will pick up my IDP at the selected store.'
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "row total",
        children: [/*#__PURE__*/_jsx("span", {
          className: "description",
          children: "Total"
        }), /*#__PURE__*/_jsxs("span", {
          className: "cost",
          children: [/*#__PURE__*/_jsx("span", {
            className: "currency",
            children: "AUD"
          }), /*#__PURE__*/_jsxs("span", {
            className: "value",
            children: ["$", (COSTS.permit + postage.cost).toFixed(2)]
          })]
        })]
      }), /*#__PURE__*/_jsx("p", {
        children: "Note: International Driving Permits are GST free"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("strong", {
          children: "Please note, once your have submitted your application, we cannot cancel your order."
        })
      })]
    });
  }
}
_defineProperty(CostTable, "defaultProps", {
  postage: {
    name: 'express_au',
    description: 'Express Post within Australia',
    cost: 11.75
  }
});
const mapStateToProps = ({
  postage
}) => {
  return {
    postage
  };
};
const VisibleCostTable = connect(mapStateToProps)(CostTable);
export default VisibleCostTable;